import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { orgCardShadow } from './organisationsUi';

type OrgSearchFieldProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
};

export function OrgSearchField({ value, onChange, placeholder }: OrgSearchFieldProps) {
  return (
    <div
      style={{
        marginBottom: 16,
        padding: '4px 0',
      }}
    >
      <Input
        allowClear
        size="large"
        prefix={<SearchOutlined style={{ color: '#98a2b3' }} />}
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        style={{
          borderRadius: 12,
          boxShadow: orgCardShadow,
          fontSize: 16,
        }}
      />
    </div>
  );
}
